
      var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgElectricity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56.524 31.33V17.277a5.06 5.06 0 0 0-10.12 0V31.33m29.235 0V17.277a5.06 5.06 0 0 0-10.12 0V31.33M55.4 65.187v5.962a2.91 2.91 0 0 0 2.908 2.91h5.426a2.91 2.91 0 0 0 2.91-2.91v-6.086",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.686 74.058c.02 8.203-.842 14.22-8.328 18.948-4.974 3.141-11.88 4.54-20.877-.342m0 0c-1.618-.878-3.274-1.99-4.957-3.372-3.675-3.13-9.597-10.252-3.883-13.697 3.405-1.544 9.954-.411 8.918 16.477a10 10 0 0 1-.078.592m0 0c-.685 4.214-4.593 12.291-15.77 15.127",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M60.767 65.267c-12.4 0-22.489-11.146-22.489-24.852v-5.742c0-1.17.956-2.116 2.132-2.116h40.713c1.179 0 2.132.949 2.132 2.116v5.742c0 13.703-10.09 24.852-22.492 24.852z",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.404 41.45v2.48a10.76 10.76 0 0 0 4.497 8.764m-35.315 4.498H34.7m-22.487-8.995h13.493",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M100.552 50.334c.472-.702 1.559-.169 1.294.634l-5.611 16.978a1.327 1.327 0 0 0 1.42 1.734l7.306-.887c1.119-.136 1.887 1.097 1.272 2.042l-17.667 27.1c-.459.705-1.547.2-1.306-.606l5.167-17.2a1.327 1.327 0 0 0-1.431-1.7l-7.312.888c-1.129.137-1.896-1.116-1.261-2.059z",
  stroke: "#810ea9",
  strokeWidth: 4.4,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\"><path d=\"M56.524 31.33V17.277a5.06 5.06 0 0 0-10.12 0V31.33m29.235 0V17.277a5.06 5.06 0 0 0-10.12 0V31.33M55.4 65.187v5.962a2.91 2.91 0 0 0 2.908 2.91h5.426a2.91 2.91 0 0 0 2.91-2.91v-6.086\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M61.686 74.058c.02 8.203-.842 14.22-8.328 18.948-4.974 3.141-11.88 4.54-20.877-.342m0 0c-1.618-.878-3.274-1.99-4.957-3.372-3.675-3.13-9.597-10.252-3.883-13.697 3.405-1.544 9.954-.411 8.918 16.477a10 10 0 0 1-.078.592m0 0c-.685 4.214-4.593 12.291-15.77 15.127\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M60.767 65.267c-12.4 0-22.489-11.146-22.489-24.852v-5.742c0-1.17.956-2.116 2.132-2.116h40.713c1.179 0 2.132.949 2.132 2.116v5.742c0 13.703-10.09 24.852-22.492 24.852z\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/><path d=\"M46.404 41.45v2.48a10.76 10.76 0 0 0 4.497 8.764m-35.315 4.498H34.7m-22.487-8.995h13.493\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M100.552 50.334c.472-.702 1.559-.169 1.294.634l-5.611 16.978a1.327 1.327 0 0 0 1.42 1.734l7.306-.887c1.119-.136 1.887 1.097 1.272 2.042l-17.667 27.1c-.459.705-1.547.2-1.306-.606l5.167-17.2a1.327 1.327 0 0 0-1.431-1.7l-7.312.888c-1.129.137-1.896-1.116-1.261-2.059z\" stroke=\"#810ea9\" stroke-width=\"4.4\" stroke-linejoin=\"round\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/electricity.612f289887612ce0eee8d19002bd87d6.svg"),
        {
          React: SvgElectricity,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      